export default "__VITE_ASSET__505968e3__"